import './Grid.svelte.css';
/* src/Grid.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	attr,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal
} from "./_snowpack/pkg/svelte/internal.js";

import { createEventDispatcher, onMount } from './_snowpack/pkg/svelte.js';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[15] = list[i];
	child_ctx[17] = i;
	return child_ctx;
}

// (68:4) {#each (pv ? enc_data : color_data) as pixel, index}
function create_each_block(ctx) {
	let div;
	let div_style_value;
	let mounted;
	let dispose;

	function mousedown_handler(...args) {
		return /*mousedown_handler*/ ctx[8](/*index*/ ctx[17], ...args);
	}

	function mousemove_handler(...args) {
		return /*mousemove_handler*/ ctx[9](/*index*/ ctx[17], ...args);
	}

	return {
		c() {
			div = element("div");
			attr(div, "class", "key-pixel svelte-16wv85t");
			attr(div, "style", div_style_value = `background-color: ${/*palette*/ ctx[4][/*pixel*/ ctx[15].color]}`);
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (!mounted) {
				dispose = [
					listen(div, "mousedown", mousedown_handler),
					listen(div, "mousemove", mousemove_handler)
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*pv, enc_data, color_data*/ 7 && div_style_value !== (div_style_value = `background-color: ${/*palette*/ ctx[4][/*pixel*/ ctx[15].color]}`)) {
				attr(div, "style", div_style_value);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let mounted;
	let dispose;

	let each_value = /*pv*/ ctx[1]
	? /*enc_data*/ ctx[0]
	: /*color_data*/ ctx[2];

	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(div, "class", "key-grid svelte-16wv85t");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			if (!mounted) {
				dispose = [
					listen(div, "mousedown", /*mousedown_handler_1*/ ctx[10]),
					listen(div, "mouseup", /*mouseup_handler*/ ctx[11]),
					listen(div, "mouseleave", /*mouseleave_handler*/ ctx[12])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*palette, pv, enc_data, color_data, mouseDown, mouseMove*/ 119) {
				each_value = /*pv*/ ctx[1]
				? /*enc_data*/ ctx[0]
				: /*color_data*/ ctx[2];

				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const dispatch = createEventDispatcher();
	let { color } = $$props;
	let { enc_data } = $$props; // Pass protected color data
	let { pv } = $$props; // Password visable
	let color_data = Array(8 * 8).fill(null).map(x => ({ color: 15 }));
	let paint = false;

	let palette = [
		'#ffffff',
		'#ffff00',
		'#ff6500',
		'#dc0000',
		'#ff0097',
		'#360097',
		'#0000ca',
		'#0097ff',
		'#00a800',
		'#006500',
		'#653600',
		'#976536',
		'#b9b9b9',
		'#868686',
		'#454545',
		'#000000'
	];

	function mouseDown(i, e) {
		$$invalidate(2, color_data[i].color = color, color_data);
		sendUpdate();
	}

	function mouseMove(i, e) {
		if (paint) {
			$$invalidate(2, color_data[i].color = color, color_data);
			sendUpdate();
		}
	}

	function sendUpdate() {
		dispatch('update', { data: color_data });
	}

	onMount(() => {
		sendUpdate();
	});

	const mousedown_handler = (index, e) => mouseDown(index, e);
	const mousemove_handler = (index, e) => mouseMove(index, e);
	const mousedown_handler_1 = e => $$invalidate(3, paint = true);
	const mouseup_handler = e => $$invalidate(3, paint = false);
	const mouseleave_handler = e => $$invalidate(3, paint = false);

	$$self.$$set = $$props => {
		if ('color' in $$props) $$invalidate(7, color = $$props.color);
		if ('enc_data' in $$props) $$invalidate(0, enc_data = $$props.enc_data);
		if ('pv' in $$props) $$invalidate(1, pv = $$props.pv);
	};

	return [
		enc_data,
		pv,
		color_data,
		paint,
		palette,
		mouseDown,
		mouseMove,
		color,
		mousedown_handler,
		mousemove_handler,
		mousedown_handler_1,
		mouseup_handler,
		mouseleave_handler
	];
}

class Grid extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { color: 7, enc_data: 0, pv: 1 });
	}
}

export default Grid;